import React from "react";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import { Link } from "react-router-dom";

const CustomerSupport = () => {
  return (
    <div className="card card-one-1 margin refund-policy-wrapper">
      <Navbar />
      <div className="refund-static-content">
        <div className="static-header">
          <h1 className="container">Customer Support</h1>
        </div>
        <div className="container mt-3">
          <p className="mb-4">
            At UpskillMeet, we are committed to providing a seamless and
            trustworthy experience for all users — both Explorers (learners) and
            Experts (mentors). Our customer support team is here to help you
            with any issues, questions, or feedback you may have.
          </p>
          <hr />
        </div>
        <div className="container">
          <h5 className="mb-3">
            <b>How to reach us?</b>
          </h5>
          <p className="mb-3">You can contact our support team through:</p>
          <ul>
            <li>
              <b>Email:</b>
              <a href="mailto:support@upskillmeet.com">
                support@upskillmeet.com
              </a>{" "}
              <br />
              Our support hours are{" "}
              <b>Monday to Saturday, 10:00 AM – 6:00 PM IST</b>
              <br />
              We strive to respond within <b>24–48 business hours.</b>
            </li>
            <li>
              <b> In-App Help</b> (Coming Soon):
              <br />
              Access help articles and contact support directly within the
              UpskillMeet platform.
            </li>
          </ul>
          <hr />
        </div>

        <div className="container">
          <h5 className="mb-3">
            <b>Common Support Topics</b>
          </h5>
          <ol>
            <li>
              <b>Booking or Scheduling Issues</b>
              <br />
              Having trouble scheduling a session or finding availability? We
              can assist with rescheduling, clarifying session times, and
              navigating calendar syncs
            </li>
            <li>
              <b>Payment and Refunds</b>
              <br />
              Questions about charges, refunds, or failed payments? Refer to our{" "}
              <Link to="../refund-policy">Refund Policy</Link> or reach out to
              us directly for any transaction-related concerns.
            </li>
            <li>
              <b>Technical Issues</b>
              <br />
              Facing audio/video problems or login errors? Our team will help
              troubleshoot and get you back on track quickly.
            </li>
            <li>
              <b>Account & Profile Support</b>
              <br />
              Need to update your contact details, bio, or service offerings?
              Contact us for assistance with profile edits and verification.
            </li>
            <li>
              <b>Reporting an Issue</b>
              <br />
              We take reports seriously. Whether it's a no-show, inappropriate
              conduct, or breach of guidelines, you can report concerns via
              email or through the session summary.
            </li>
          </ol>
          <hr />
        </div>

        <div className="container">
          <h5 className="mb-3">
            <b>Grievance Redressal</b>
          </h5>
          <p>
            If you have a complaint or feel your issue has not been resolved to
            your satisfaction:
          </p>
          <p>
            <b>Grievance Officer</b>
          </p>
          <p>
            Name: <b>Gauthami</b> <br />
            Email:{" "}
            <a href="mailto:admin@upskillmeet.com">admin@upskillmeet.com</a>
            <br />
            Address:{" "}
            <b>
              AVANAD TECHPROSERVE, G2-F1, VGN Minerva, Nolambur, Mogappair West,
              Chennai - 600095, Tamil Nadu, India
            </b>
          </p>
          <p>
            We are committed to resolving grievances within{" "}
            <b>15 business days</b>.
          </p>
          <hr />
        </div>

        <div className="container">
          <h5 className="mb-3">
            <b>Support Policy Highlights</b>
          </h5>
          <ul>
            <li>
              We do <b>not</b> offer phone-based customer support at this time.
            </li>
            <li>
              Support is available in <b>English</b> only.
            </li>
            <li>
              All support requests must come from your registered email address
              for verification
            </li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CustomerSupport;
